import React, { Component } from 'react'
import { connect } from 'react-redux'
import { login } from '../../store/actions/auth'
import { jsonUploadCall } from '../../helpers/api/api'
import Dots from '../../components/activityIndicators/dots'
import '../main.css'
import Logo from '../../images/panellogo.png'


class Login extends Component {
    constructor(props) {
        super(props)
        this.state = {
            userName: "",
            password: "",
            errorMessage: "",
            sending: false
        }
    }

    componentDidMount(){
        if(this.props.token !== ""){
            this.props.history.push("/bitkiCesitleri")
        }
    }

    async onChange(e, prop) {
        await this.setState({ [prop]: e.target.value.trim() })
    }

    async send() {
        await this.setState({ sending: true })
        const res = await jsonUploadCall("/auth", this.state)
        if (res.data === "kullanıcı adı ya da parola yanlış") {
            await this.setState({ errorMessage: "kullanıcı adı ya da parola yanlış" })
        } else {
            await login(res.data)
            this.props.history.push("bitkiCesitleri")
        }

        await this.setState({ sending: false })
    }

    render() {
        if (this.state.sending) {
            return (
                <Dots />
            )
        }
        return (
            <div style={styles.container}>
                <img src={Logo} style={styles.image} />
                <form style={styles.formContainer}>
                    <p style={styles.header}>Yönetim Paneli</p>
                    <label style={styles.label}>Kullanıcı Adı</label>
                    <input type="text" style={{ border: "2px solid #DCE4EC" }} value={this.state.userName} placeholder="Kullanıcı Adınız" onChange={async e => { await this.onChange(e, "userName"); }} className="data-text-input"></input>
                    <label style={styles.label}>Parola</label>
                    <input type="password" style={{ border: "2px solid #DCE4EC" }} value={this.state.password} placeholder="Parolanız" onChange={async e => { await this.onChange(e, "password"); }} className="data-text-input"></input>
                    {this.state.errorMessage && <p style={{ color: "red" }}>{this.state.errorMessage}</p>}
                    <button onClick={() => this.send()} style={{ fontSize: "14px" }} className="save-button">Giriş</button>
                </form>
            </div>
        )
    }
}

const styles = {
    container: {
        display: "flex",
        alignItems: "center",
        marginTop: "20px",
        flexDirection: "column"
    },
    header: {
        fontSize: "22.5px",
        color: "#2c3e50",
        borderBottom: "1px solid #e5e5e5",
        marginBottom: "17px"
    },
    label: {
        fontSize: "12px",
        fontWeight: "bold",
        color: "#2c3e50",
        marginBottom: "3px"
    },
    formContainer: {
        width: "360px",
    },
    image: {
        width: "350px",
        height: "auto"
    }
}

export default connect((store) => ({token: store.auth.token}), {login})(Login)
